import { CookieOptionsArgs } from './cookie-options-args';

export class CookieOptions {
  public path: string;
  public domain: string;
  public expires: string|Date;
  public secure: boolean;

  constructor({path, domain, expires, secure}: CookieOptionsArgs = {}) {
    this.path = this.isPresent(path) ? path : null;
    this.domain = this.isPresent(domain) ? domain : null;
    this.expires = this.isPresent(expires) ? expires : null;
    this.secure = this.isPresent(secure) ? secure : false;
  }

  public merge(options?: CookieOptionsArgs): CookieOptions {
    return new CookieOptions(<CookieOptionsArgs>{
      path: this.isPresent(options) && this.isPresent(options.path) ? options.path : this.path,
      domain: this.isPresent(options) && this.isPresent(options.domain) ? options.domain : this.domain,
      expires: this.isPresent(options) && this.isPresent(options.expires) ? options.expires : this.expires,
      secure: this.isPresent(options) && this.isPresent(options.secure) ? options.secure : this.secure,
    });
  }

  private isPresent(obj: any): boolean {
    return obj !== undefined && obj !== null;
  }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/cookie/cookie-options.ts